import React, { memo } from 'react';
import styles from './home.module.css';
import { typeToIcon, ChainType, chainName } from './chain';

export interface IStaticChainProps {
  chain: ChainType;
}

const StaticChain: React.FC<IStaticChainProps> = ({ chain }) => {
  const IconComponent = typeToIcon[chain];
  return (
    <div className={styles.chain}>
      <IconComponent className={styles.chainIcon} />
      <span className={styles.chainText}>{chainName[chain]}</span>
    </div>
  );
};

export default memo(StaticChain);
